export default __webpack_public_path__ + "static/media/Texto_.9e84847d.png";